import api from '@shared/services/api';
import i18n from '@/i18n/i18n';

export const nomenclaturesOz = {
    getNomenclaturesOz: async () => {
        try {
            const currentLanguage = i18n.language === 'bg' ? 'bg_BG' : 'en_US';
            const response = await api.get(`/c-nomenclature?language=${currentLanguage}`);
            return response.data;
        } catch (error) {
            console.error('Error getting nomenclatures Oz:', error);
            throw error;
        }
    },
    
    getNomenclatureItems: async (nomenclatureId, active) => {
        try {
            const currentLanguage = i18n.language === 'bg' ? 'bg_BG' : 'en_US';
            
            const url = `/nomenclature-item/${nomenclatureId}?language=${currentLanguage}&active=${active}`;
            
            
            const response = await api.get(url);
            return response.data;
        } catch (error) {
            console.error('❌ [nomenclaturesOzService] Error getting nomenclature items:', error);
            throw error;
        }
    },

    getNomenclatureName: async (nomenclatureItemId) => {
        try {
            const response = await api.get(`/nomenclature-item/get//${nomenclatureItemId}`);
            return response.data.nomenclatureItemLngs;
        } catch (error) {
            console.error('Error getting nomenclature name:', error);
            throw error;    
        }
    },

    createNomenclatureItem: async (data) => {
        try {
            const response = await api.post('/nomenclature-item', data);
            return response.data;
        } catch (error) {
            console.error('Error creating nomenclature item:', error);
            throw error;
        }
    },

    updateNomenclatureItem: async (id, data) => {
        try {
            const response = await api.put(`/nomenclature-item/${id}`, data);
            return response.data;
        } catch (error) {
            console.error('Error updating nomenclature item:', error);
            throw error;
        }
    },

    deleteNomenclatureItem: async (id) => {
        try {
            const response = await api.delete(`/nomenclature-item/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting nomenclature item:', error);
            throw error;
        }
    },
};  